
import DialogCircleCloseBtn from "../common/dialog-circle-close-btn.vue";

export default {
  components: { DialogCircleCloseBtn },
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    dialogWidth: {
      type: String,
      default: "500"
    },
    dialogContentClass: {
      type: String,
      default: ""
    },
    persistent: {
      type: Boolean,
      default: false
    },
    scrollable: {
      type: Boolean,
      default: false
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    isCircularCloseButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      state: this.dialog
    };
  },
  watch: {
    state(val) {
      if (!val) this.handleClose();
    }
  },
  methods: {
    handleClose(e) {
      this.$emit("close-dialog");
    }
  }
};
